import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { DIGIO_ENV, APP_URL, V1_API_ORIGIN } from "../../config/constants.config";
import { MakePaymentProcess } from './MakePaymentProcess';
import { IndianRupee } from 'lucide-react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import states from "../state.json";
import * as Yup from "yup";
import { requestSignDocument, digioSignedUpdatePayment, getKYCDetails, paymentOnCashFree, paymentRequest, cancelSignDocument } from "../../api/pricing";
import { useNavigate } from 'react-router';
import { getCashfree } from "../../utils/cashfree";
// import { handleScrollToTop, useDocumentTitle } from './Common';
import axios from 'axios';
import moment from 'moment';
// import axiosInstance from '../axiosInstance';
// import { useTheme } from '../hooks/useTheme';
// import {
//   accessibilityFontScaleStyles,
//   useAccessibilityFontScale,
// } from '../hooks/useAccessibilityFontScale';
// import Detail from '../pages/layout/interface/guest/detail';
import { useDocumentTitle } from '../../utils/Common';
import axiosInstance from '../../api/axiosInstance';
import { useTheme } from '../../utils/theme';
import Layout from '../layout/Layout';


export default function Checkout() {
  const [data, setData] = useState(null);
  // const { fontScale } = useAccessibilityFontScale();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const authState = useSelector((state) => state.auth.authState);
  const buttonRef = useRef();
  const router = useNavigate();
  const [requestSignData, setRequestSignData] = useState({});
  const [digioSignUpdate, setDigioSignUpdate] = useState({
    status: "",
    details: {},
  });
  const [paymentLoading, setPaymentLoading] = useState(true);
  const [hasUserDataBeforePayment, setHasUserDataBeforePayment] = useState({
    cusCountry: "INDIA",
    cusState: "",
    cusCity: "",
  });
  const [canSelectPlan, setCanSelectPlan] = useState([
    "Conservative",
    "Moderate",
    "Aggressive",
  ]);
  const [showModal, setShowModal] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [InitializeCashfree, setInitializeCashfree] = useState(false);
  const [PaymentData, setPaymentData] = useState(false)
  const [Rpfdata, setRpfdata] = useState(null)
  useDocumentTitle("Checkout");
  const [paymentId, setPaymentId] = useState(localStorage.getItem("pid") || null);
  const primaryThemeButtonClass = "btn";
  const primaryThemeButtonStyle = {
    backgroundColor: "var(--bs-emphasis-color)",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-body-bg)",
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedData = localStorage.getItem("cz");
        if (storedData) {
          setData(JSON.parse(storedData));
          // handleScrollToTop();
          const planKey = Object.keys(JSON.parse(storedData).planData)[0]; // Get the first key dynamically
          const plan = JSON.parse(storedData).planData[planKey];
          await axiosInstance
            .get(`${V1_API_ORIGIN}/payments?userId=${userDetail.id}&perPage=10&currentPage=1`)
            .then((response) => {
              setPaymentLoading(true);
              const { dataList } = response.data.data;

              // Get FIRST match among all records
              const matchedPayment = dataList.filter((item) => (item.digioDocSignStatus == "success" && item.payStatus == "processing")).find((item) => {
                const paymentCartItem =
                  item.paymentType === "bundle" ? item : item.cartItems[0];
                const isDigioValid = moment(item.digioValidTill).isAfter(moment())
                const isMatch =
                  plan &&
                  isDigioValid &&
                  (item.pacAmount == (plan.discountPrice == 0 ? plan.actualPrice : plan.discountPrice)) &&
                  (paymentCartItem?.name === plan.name || paymentCartItem?.name === plan.bundleName) &&
                  ((paymentCartItem?.paymentType == "bundle" ? paymentCartItem?.cartItems[0].pacDuration : paymentCartItem?.pacDuration) === (plan.bundleName ? plan.duration : plan.planDuration));

                return isMatch;
              });

              // Set paymentId if match
              if (matchedPayment) {
                setPaymentId(matchedPayment.id);
              }

              setPaymentData(!!matchedPayment);
              setPaymentLoading(false);
              // setPaymentId(response.data.data.dataList[0]?.id)
              // const paymentCartItem = response.data.data.dataList[0]?.paymentType == "bundle" ? response.data.data.dataList[0] : response.data.data.dataList[0]?.cartItems[0];
              // const isDigioValid = response.data.data.dataList[0]?.digioValidTill && (moment(response.data.data.dataList[0]?.digioValidTill).isAfter(moment(), 'day') || (moment(response.data.data.dataList[0]?.digioValidTill).isBefore(moment().endOf('day')) && moment(response.data.data.dataList[0]?.digioValidTill).isAfter(moment().startOf('day'))))
              // const isMatch =
              //   plan &&
              //   isDigioValid &&
              //   (paymentCartItem?.name === plan.name || paymentCartItem?.name === plan.bundleName) &&
              //   ((paymentCartItem?.paymentType == "bundle" ? paymentCartItem?.cartItems[0].pacDuration : paymentCartItem?.pacDuration) === (plan.bundleName ? plan.duration : plan.planDuration));
              // setPaymentData(isMatch);
            });
        }
        else {
          router("/pricing");
        }
      } catch (error) {
        console.error("Error loading payment data:", error);
        router("/pricing");
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    console.log(userDetail.rpfProfileType);
    const fetchRpf = async () => {
      try {
        const response = await axiosInstance.get(
          `${V1_API_ORIGIN}/rpfs/${userDetail.rpfId}`
        );

        setRpfdata(response.data.data);
      } catch (error) {
        console.error("Error fetching RPF data:", error);
      }
    };
    fetchRpf();
    if (userDetail.rpfProfileType === "Conservative" || userDetail.rpfProfileType === "filled")
      setCanSelectPlan(["Conservative"]);
    else if (userDetail.rpfProfileType === "Moderate")
      setCanSelectPlan(["Conservative", "Moderate"]);
    else if (userDetail.rpfProfileType === "Aggressive")
      setCanSelectPlan(["Conservative", "Moderate", "Aggressive"]);
    else if (!userDetail.rpfProfileType)
      //if rpf not filled
      setCanSelectPlan(["Conservative", "Moderate", "Aggressive"]);
  }, [userDetail.rpfProfileType])

  const isHidden =
    !data || !data.planData || Object.keys(data.planData).length === 0
      ? "d-none"
      : "";
  // const isHidden = "d-none"
  const handleClose = () => {
    localStorage.removeItem("cz");
    setData(null);
  };
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const validationSchema = Yup.object({
    cusCountry: Yup.string()
      .optional("Country is required")
      .max(100, "Country should be less then 100 characters."),
    cusState: Yup.string()
      .optional("State is required")
      .max(100, "State should be less then 100 characters."),
    cusCity: Yup.string()
      .optional("City is required")
      .max(100, "City should be less then 100 characters."),
  });


  const submit = async (values) => {
    setHasUserDataBeforePayment(values);

    const valueClone = {
      ...values,
      total: data.total,
      gst: data.gst,
      grandTotal: data.grandTotal,
      isPaymentRequest: data.isPaymentRequest,
      paymentId: data.paymentId,
      isRecurringPayment: data.IsRecurringOptionOpen
    };
    if (Object.keys(data.planData)[0] == 1000 || Object.keys(data.planData)[0] == 1001) {
      delete valueClone.gst;
      delete valueClone.grandTotal;
    }

    let params = {
      id: Object.values(data.planData)[0].id,
      paymentType: data.isPaymentRequest
        ? "request"
        : Object.values(data.planData)[0].bundleName
          ? "bundle"
          : "individual", // "individual", "bundle", "request"
      cusCity: valueClone.cusCity,
      cusState: valueClone.cusState,
      cusCountry: valueClone.cusCountry,
      isRecurringPayment: data.IsRecurringOptionOpen
    };
    let payload = { ...params };
    for (const key in payload) {
      if (payload[key] === "" || payload[key] === 0) delete payload[key];
    }

    if (PaymentData) {
      setInitializeCashfree(true);
      paymentOnCashFree(paymentId, data.IsRecurringOptionOpen).then((response) => {
        if (response?.data?.status) {
          if (data.IsRecurringOptionOpen) {
            doPayment(response.data?.data?.subscription_session_id, paymentId, data.IsRecurringOptionOpen);
          } else {
            doPayment(response.data?.data?.payment_session_id);
          }
        }
      });
    } else {
      localStorage.setItem("czSignPayload", JSON.stringify(payload));
      const uid = localStorage.getItem("uid");
      axiosInstance
        .get(`${V1_API_ORIGIN}/kyc/get-by-userId/${uid}`)
        .then((res) => {
          requestSignDocument(payload)
            .then((response) => {
              setRequestSignData(response.data.data);
            })
            .catch((e) => {
              alert(e.response?.data?.message);
            });
        })
        .catch(() => {
          router("/kyc");
        });
    }
  };
  useEffect(() => {
    if (typeof requestSignData.id !== "undefined") {
      window.paymentID = requestSignData.paymentId;
      const digio = new window.Digio({
        environment: DIGIO_ENV,
        callback: async (response) => {
          if (
            response.hasOwnProperty("error_code") &&
            response.error_code === "CANCELLED"
          ) {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "CANCELLED",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
          } else {
            setDigioSignUpdate((prevState) => ({
              ...prevState,
              status: "SUCCESS",
              details: { ...response, paymentID: window.paymentID },
            }));
            setShowModal(false);
            setShowLoader(true)
          }
        },
        theme: {
          darkColor: "#AB3498",
          secondaryColor: "#000000",
        },
        Is_redirection_approach: false,
        is_iframe: true,
      });
      digio.init();
      digio.submit(
        requestSignData.id,
        requestSignData.signing_parties[0]?.identifier,
        requestSignData.access_token?.id
      );
    }
  }, [requestSignData]);
  useEffect(() => {
    if (digioSignUpdate.status === "SUCCESS") {
      digioSignedUpdatePayment({
        paymentId: digioSignUpdate.details.paymentID,
        digioDesc: "Signed",
        digioDocId: digioSignUpdate.details.digio_doc_id,
        digioDocSignStatus: "success",
      }).then(() => {
        localStorage.setItem("pid", window.paymentID);
        setInitializeCashfree(true);
        setShowModal(false);
        // navigate(`/make-payment`);
        // handleScrollToTop();
        paymentOnCashFree(digioSignUpdate.details.paymentID, data.IsRecurringOptionOpen).then(
          (response) => {
            if (data.IsRecurringOptionOpen) {
              doPayment(response.data?.data?.subscription_session_id, data.IsRecurringOptionOpen);
            } else {
              doPayment(response.data?.data?.payment_session_id);
            }
          }
        );
      });

      // paymentRequest()
      //   .then((response) => {
      //     const options = {
      //       key: RAZORPAY_KEY,
      //       amount: response.data.data.amount.toString(),
      //       currency: "INR",
      //       name: "Equitypandit Financial Services Private Limited",
      //       description: "Packages",
      //       image: `/ep-imgs/EPfavicon.png`,
      //       order_id: response.data.data.id,
      //       handler: function (response) {
      //         updateRazorpaySuccess({
      //           payStatus: "success",
      //           razorpayOrderId: response.razorpay_order_id,
      //           razorpayPaymentId: response.razorpay_payment_id,
      //         }).then(() => {
      //           getKYCDetails()
      //             .then((response) => {
      //               setHasKycData(response.data.data);
      //               if (response.data.data?.id !== undefined) {
      //                 // navigate("/my-services");
      //               }
      //             })
      //             .catch(() => {
      //               // buttonRefPopInitiator.current.click();
      //             });
      //         });
      //       },
      //       prefill: {
      //         name: userDetail.firstName, email: userDetail.email, contact: userDetail.mobile,
      //       },
      //       theme: {
      //         color: "#008254",
      //       },
      //     };
      //
      //     const paymentObject = new window.Razorpay(options);
      //     paymentObject.open();
      //   });
    } else if (digioSignUpdate.status === "CANCELLED") {
      setInitializeCashfree(true);
      setShowModal(false);
      setShowLoader(false);
      cancelSignDocument(digioSignUpdate.details.digio_doc_id);
    }
  }, [digioSignUpdate.status]);
  const doPayment = async (payId, isRecurringPayment) => {
    const cashfree = await getCashfree();

    if (isRecurringPayment) {
      let checkoutOptions = {
        subsSessionId: payId,
        // redirectTarget: "_blank",
      };
      // cashfree.checkout(checkoutOptions).then((result) => {
      cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {

        if (result.error) {
          // handleScrollToTop();
          router("/txn/failure");
          setInitializeCashfree(false);
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log(
            "User has closed the popup or there is some payment error, Check for Payment Status"
          );
          console.log(result.error);
        }
        if (result.redirect) {
          console.log("hereeee");

          // setInitializeCashfree(false);
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          localStorage.setItem("pid", window.paymentID ? window.paymentID : paymentId);
          localStorage.removeItem("cz");
          localStorage.removeItem("czSignPayload");
          axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID ? window.paymentID : paymentId}`, {
            payStatus: "success",
          });
          axiosInstance.get(
            `${V1_API_ORIGIN}/payments/active-services/${window.paymentID || paymentId}`
          );
          setShowLoader(false);
          setInitializeCashfree(false);
          // router("/txn/success");
          router("/kyc");
          // window.location.reload();
          // handleScrollToTop();
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
        }
      });
    }
    else {
      let checkoutOptions = {
        paymentSessionId: payId,
        redirectTarget: "_modal",
      };
      cashfree.checkout(checkoutOptions).then((result) => {
        // cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {

        if (result.error) {
          // handleScrollToTop();
          router("/txn/failure");
          setInitializeCashfree(false);
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          console.log(
            "User has closed the popup or there is some payment error, Check for Payment Status"
          );
          console.log(result.error);
        }
        if (result.redirect) {
          setInitializeCashfree(false);
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          localStorage.setItem("pid", window.paymentID ? window.paymentID : paymentId);
          localStorage.removeItem("cz");
          localStorage.removeItem("czSignPayload");
          axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID ? window.paymentID : paymentId}`, {
            payStatus: "success",
          });
          axiosInstance.get(
            `${V1_API_ORIGIN}/payments/active-services/${window.paymentID || paymentId}`
          );
          setInitializeCashfree(false);
          // router("/txn/success");
          router("/kyc");
          // window.location.reload();
          // handleScrollToTop();
          // This will be called whenever the payment is completed irrespective of transaction status
          console.log("Payment has been completed, Check for Payment Status");
          console.log(result.paymentDetails.paymentMessage);
        }
      });
    }
  };
  const { theme, isDark } = useTheme();

  return (
    // <Layout>
    // <div className="ep-font-scale" style={{ "--ep-font-scale": fontScale }}>
    <div className="ep-font-scale " >
      {/* <style>{accessibilityFontScaleStyles}</style> */}
      <section className='vh-100' style={{ backgroundColor: theme === "dark" ? "#000000" : undefined }}>
        {ShowLoader ?
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25" style={{ zIndex: 1050 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          :
          <div className={`container py-2 ${isHidden} ${ShowLoader ? "d-none" : ""}}`}>
            <div className='row justify-content-center'>
              <div className='col-md-4 text-center'>
                <button
                  type="button"
                  className="btn p-0 border-0 bg-transparent shadow-none"
                  onClick={() => router('/dashboard')}
                  aria-label="Go to dashboard"
                >
                  {/* <img
                    loading="lazy"
                    className="mb-1 py-3"
                    src={
                      theme == "dark"
                        ? "/ep-wealth/25.svg"
                        : "/ep-imgs/ep-advisor-logo.svg"
                    }
                    alt="EP-Investment-Advisor"
                  />
                  <small className='d-block'><small>SEBI Registration Number: INA000006688</small></small> */}
                </button>
              </div>
            </div>
            <div className="row g-0 justify-content-center">
              <div
                className="col-md-4 h-100 text-center"
                style={{
                  backgroundColor: theme === "dark" ? "#050505" : "#ffffff",
                  border: theme === "dark" ? "1px solid #111111" : "1px solid #dfe3e8",
                  borderRadius: "18px",
                  padding: "1.5rem 1.25rem",
                  boxShadow: theme === "dark"
                    ? "0 18px 48px rgba(0, 0, 0, 0.35)"
                    : "0 18px 48px rgba(15, 23, 42, 0.08)",
                }}
              >

                {/* Close Button */}
                {/* <button
              type="button"
              className="btn-close btn-sm position-absolute top-0 end-0 mt-2 me-2"
              aria-label="Close"
              onClick={() => {
                // Add your close logic here, e.g., setting state to hide the component
                // console.log("Close button clicked");
                localStorage.removeItem("cz");
                setData(null);
              }}
            ></button> */}
                <div
                  className={`row text-center`}
                  key={`condition1-${data?.componentKey}`}
                >
                  {data && data.planData && (
                    <>
                      {/* Get dynamic plan */}
                      {(() => {
                        const planKey = Object.keys(data.planData)[0]; // Get the first key dynamically
                        const plan = data.planData[planKey];
                        return (
                          <>
                            <div className="col-md-12">
                              {console.log(plan?.rpfType)}
                              {canSelectPlan.find(
                                (option) => option === plan?.rpfType
                              ) ? (
                                <>
                                  <div className={`${!userDetail.rpfProfileType ? "d-none" : ""} bg-success bg-opacity-10`}>
                                    <div className='p-3'>

                                      <p className="fw-semibold fs-5 ">
                                        Your profile is{" "}
                                        <span
                                          className={` ${userDetail.rpfProfileType == "Aggressive"
                                            ? "text-success"
                                            : userDetail.rpfProfileType == "Moderate"
                                              ? "text-warning"
                                              : "text-danger"
                                            }`}
                                        >
                                          {userDetail.rpfProfileType}
                                        </span>
                                      </p>
                                      {userDetail.rpfProfileType === "Aggressive" && (
                                        <img
                                          src={theme == 'dark' ? `${APP_URL}/assets/img/aggressive-2.png` : `${APP_URL}/assets/img/aggressive.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                      {userDetail.rpfProfileType === "Moderate" && (
                                        <img
                                          src={theme == 'dark' ? `${APP_URL}/assets/img/moderate-2.png` : `${APP_URL}/assets/img/moderate.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                      {userDetail.rpfProfileType === "Conservative" && (
                                        <img
                                          src={theme == 'dark' ? `${APP_URL}/assets/img/conservative-2.png` : `${APP_URL}/assets/img/conservative.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                    </div>
                                    <hr className='p-0 m-0 text-success' />
                                    <small className="text-success my-2 fw-medium">
                                      <span className="text-uppercase">
                                        {plan.name || plan.bundleName}
                                      </span>{" "}
                                      is suitable to your profile.
                                    </small><div className="row justify-content-between mt-1">
                                    </div>
                                    <hr className=' p-0 m-0 text-success' />

                                  </div>
                                  {(userDetail?.email && userDetail?.firstName) ? <>
                                    <div className="row justify-content-center rounded-3 g-1 mb-2">
                                      <div className="col-11 py-2 d-flex justify-content-start">
                                        <p className="fw-semibold mb-0">Personal details</p>
                                      </div>
                                      <div className="col-11 py-1 d-flex justify-content-between">
                                        <small className="text-muted">Name</small>
                                        <small>
                                          {userDetail.firstName}
                                        </small>
                                      </div>
                                      <div className="col-11 py-1 d-flex justify-content-between">
                                        <small className="text-muted">Email</small>
                                        <small>
                                          {userDetail.email}
                                        </small>
                                      </div>
                                      <div className="col-11 py-1 d-flex justify-content-between">
                                        <small className="text-muted">Mobile</small>
                                        <small>
                                          {userDetail.mobile}
                                        </small>
                                      </div>
                                    </div>

                                    <div className="row justify-content-center rounded-3">
                                      <div className="col-11 py-2 d-flex justify-content-between">
                                        <p className="fw-semibold mb-0">Order Summary</p>
                                        <p className="accordion-header m-0 text-end">
                                          <button
                                            className="accordion-button collapsed bg-transparent border-0 p-0 shadow-none d-inline-flex align-items-center gap-1 small"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#flush-collapseOne"
                                            style={{ color: "var(--bs-primary)", WebkitTextFillColor: "var(--bs-primary)" }}
                                          >
                                            View Breakdown
                                          </button>
                                        </p>

                                      </div>

                                      {/* <div className="col-md-11 p-1 m-0 p-md-0 d-flex justify-content-between">
                                      <small className="">{plan.name || plan.bundleName}</small>
                                      <small>
                                        {plan?.planDuration ||
                                          plan?.duration}{" "}
                                        {plan?.durationType}
                                      </small>
                                    </div> */}
                                      <div className="accordion accordion-flush" id="accordionFlushExample">
                                        <div className="accordion-item border-0 rounded">
                                          <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className={isDark ? "welcome-hero-dark-section accordion-body" : "welcome-hero-light accordion-body"}>
                                              <div className="col-12 py-1 d-flex justify-content-between">
                                                <small className="text-muted">Duration</small>
                                                <small>
                                                  {plan?.planDuration ||
                                                    plan?.duration}{" "}
                                                  {plan?.durationType}
                                                </small>
                                              </div>
                                              <div className="col-12 py-1 d-flex justify-content-between">
                                                <small className="text-muted">Sub Total</small>
                                                <small className="">
                                                  <IndianRupee size={12} />
                                                  {data.total?.toLocaleString("en-IN")}
                                                </small>
                                              </div>
                                              <div className="col-12 py-1 d-flex justify-content-between">
                                                <small className="text-muted">GST (18%)</small>
                                                <small>
                                                  <IndianRupee size={12} />
                                                  {data.gst?.toLocaleString("en-IN")}
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-11 py-1 d-flex justify-content-between">
                                        <small className="fw-semibold">Total</small>
                                        <small className='fw-semibold me-1'>
                                          <IndianRupee size={12} />
                                          {data.grandTotal?.toLocaleString("en-IN")}
                                        </small>
                                      </div>
                                    </div>

                                    <Formik
                                      enableReinitialize
                                      initialValues={{
                                        cusCountry: "INDIA",
                                        cusState: userDetail.state,
                                        cusCity: "",
                                      }}
                                      validationSchema={validationSchema}
                                      onSubmit={(values, { setSubmitting, resetForm }) => {
                                        setShowLoader(true);
                                        submit(values).then(() => {
                                          setSubmitting(false);
                                          resetForm();
                                        });
                                      }}
                                    >
                                      {({ isSubmitting, touched, errors, values }) => (
                                        <Form>
                                          <div className="row justify-content-center g-3 mt-1">
                                            <div className="col-md-4 col-6 d-none">
                                              <small className="d-block text-muted">
                                                Country
                                              </small>
                                              <Field
                                                as="select"
                                                name="cusCountry"
                                                className={`form-control form-control-sm ${touched.cusCountry &&
                                                  errors.cusCountry &&
                                                  "is-invalid"
                                                  }`}
                                                value={values.cusCountry}
                                              >
                                                <option value="">-- Select --</option>
                                                <option value="INDIA">INDIA</option>
                                                <option value="other">Other</option>
                                              </Field>
                                              <ErrorMessage
                                                name="cusCountry"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </div>

                                            {values.cusCountry === "INDIA" ? (
                                              <div
                                                className={`col-md-8 ${userDetail.state ? "d-none" : ""
                                                  }`}
                                              >
                                                <small className="d-block text-muted">
                                                  Please Select Your State
                                                </small>
                                                <Field
                                                  as="select"
                                                  name="cusState"
                                                  className={`form-control form-control-sm text-center ${touched.cusState &&
                                                    errors.cusState &&
                                                    "is-invalid"
                                                    }`}
                                                  // required={true}
                                                  value={values.cusState}
                                                >
                                                  <option value="">--Select --</option>
                                                  {states.map((item, index) => (
                                                    <option value={item.value} key={index}>
                                                      {item.text}
                                                    </option>
                                                  ))}
                                                </Field>
                                                <ErrorMessage
                                                  name="cusState"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            ) : (
                                              <div className="col-md-4 col-6">
                                                <small className="d-block text-muted">
                                                  State
                                                </small>
                                                <Field
                                                  className={`form-control form-control-sm ${touched.cusState &&
                                                    errors.cusState &&
                                                    "is-invalid"
                                                    }`}
                                                  value={values.cusState}
                                                  name="cusState"
                                                // required={true}
                                                />
                                                <ErrorMessage
                                                  name="cusState"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            )}

                                            <div className="col-md-4 col-6 d-none">
                                              <small className="d-block text-muted">City</small>
                                              <Field
                                                className={`form-control form-control-sm ${touched.cusCity &&
                                                  errors.cusCity &&
                                                  "is-invalid"
                                                  }`}
                                                value={values.cusCity}
                                                name="cusCity"
                                              // required={true}
                                              />
                                              <ErrorMessage
                                                name="cusCity"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </div>
                                            {!userDetail.rpfProfileType &&
                                              <div className={`mb-2 d-none`}>
                                                Please fill RPF to Proceed <br />
                                                <button className='btn btn-success btn-sm' onClick={() => { router("/risk-profile") }} >Complete RPF</button>
                                              </div>
                                            }
                                            {!userDetail.rpfProfileType &&
                                              <div className={`mb-2 p-3`}>
                                                Please complete your risk profile to proceed. <br />
                                                <button className='btn btn-success btn-sm mt-2' onClick={() => { router("/risk-profile") }} >Continue</button>
                                              </div>
                                            }
                                            {(userDetail.rpfProfileType && !Rpfdata?.isOnline) &&
                                              <div className={`mb-2 p-3`}>
                                                Please complete your risk profile to proceed. <br />
                                                <button className='btn btn-success btn-sm mt-2' onClick={() => { router("/risk-profile") }} >Continue</button>
                                              </div>
                                            }
                                            <div
                                              className={`col-md-11 ${(userDetail.rpfProfileType && Rpfdata?.isOnline) && authState
                                                ? ""
                                                : "d-none"
                                                }`}
                                            >
                                              <div className="col-11 ms-3 ms-md-0 col-md-12">
                                                <button
                                                  type="submit"
                                                  className={`${primaryThemeButtonClass} w-100`}
                                                  style={primaryThemeButtonStyle}
                                                  disabled={
                                                    paymentLoading || // ⬅️ block button until PaymentData resolved
                                                    isSubmitting ||
                                                    (!userDetail.rpfProfileType && authState) ||
                                                    !values.cusState
                                                  }
                                                >
                                                  {console.log(PaymentData)}
                                                  {paymentLoading
                                                    ? "Checking..."
                                                    : isSubmitting
                                                      ? "Loading..."
                                                      : PaymentData
                                                        ? "Pay Now"
                                                        : "E-Sign Now"}
                                                </button>

                                              </div>
                                              <p></p>
                                            </div>
                                          </div>
                                        </Form>
                                      )}
                                    </Formik>
                                      <small className={(userDetail.rpfProfileType && Rpfdata?.isOnline) && authState ? 'mt-2 mb-0': "d-none"}>
                                        <small className="text-muted">
                                          This process will require your
                                          Adhaar Card Number.
                                        </small>
                                      </small>
                                    </> : <div className='p-3' style={{ backgroundColor: theme === "dark" ? "#050505" : undefined, border: theme === "dark" ? "#11111" : undefined }}> </div>}
                                </>
                              ) : (
                                <>
                                  <div className={`${!userDetail.rpfProfileType ? "d-none" : ""} bg-danger bg-opacity-10`}>
                                    <div className='p-3 mb-2'>

                                      <p className="fw-semibold fs-5 ">
                                        Your profile is{" "}
                                        <span
                                          className={` ${userDetail.rpfProfileType == "Aggressive"
                                            ? "text-success"
                                            : userDetail.rpfProfileType == "Moderate"
                                              ? "text-warning"
                                              : "text-danger"
                                            }`}
                                        >
                                          {userDetail.rpfProfileType}
                                        </span>
                                      </p>
                                      {userDetail.rpfProfileType === "Aggressive" && (
                                        <img
                                          src={`${APP_URL}/assets/img/aggressive.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                      {userDetail.rpfProfileType === "Moderate" && (
                                        <img
                                          src={`${APP_URL}/assets/img/moderate.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                      {userDetail.rpfProfileType === "Conservative" && (
                                        <img
                                          src={`${APP_URL}/assets/img/conservative.png`}
                                          className="img-fluid w-75"
                                          alt="rpf"
                                        />
                                      )}
                                    </div>

                                  </div>
                                  <small className="d-block text-body-emphasis">
                                    <span className="fw-bold text-capitalize">
                                      {plan.name.toLowerCase() || plan.bundleName.toLowerCase()}
                                    </span>{" "}
                                    is suitable only for Aggressive profile.
                                  </small>
                                  <button
                                    className="btn btn-dark my-2"
                                    onClick={() => {
                                      router("/risk-profile");
                                    }}
                                  >
                                    <small>
                                      {" "}
                                      Reassess your risk profile{" "}
                                    </small>{" "}
                                  </button>
                                  {/* <small className="d-block mt-2">
                                    <small>- or -</small>
                                  </small>
                                  <button
                                    className="btn w-100 text-primary text-decoration-underline"
                                    onClick={() => {
                                      router("/suitable-packages");
                                    }}
                                  >
                                    <small>
                                      View Other Suitable Services
                                    </small>
                                  </button> */}
                                  <div className="row justify-content-center rounded-3 g-1 mb-2">
                                    <div className="col-11 py-2 d-flex justify-content-start">
                                      <p className="fw-semibold mb-0">Personal details</p>
                                    </div>
                                    <div className="col-11 py-1 d-flex justify-content-between">
                                      <small className="text-muted">Name</small>
                                      <small>
                                        {userDetail.firstName}
                                      </small>
                                    </div>
                                    <div className="col-11 py-1 d-flex justify-content-between">
                                      <small className="text-muted">Email</small>
                                      <small>
                                        {userDetail.email}
                                      </small>
                                    </div>
                                    <div className="col-11 py-1 d-flex justify-content-between">
                                      <small className="text-muted">Mobile</small>
                                      <small>
                                        {userDetail.mobile}
                                      </small>
                                    </div>
                                  </div>
                                  <div className="row justify-content-center rounded-3">
                                    <div className="col-11 py-2 d-flex justify-content-between">
                                      <p className="fw-semibold mb-0">Order Summary</p>
                                      <p className="accordion-header m-0 text-end">
                                        <button
                                          className="accordion-button collapsed bg-transparent border-0 text-primary p-0 shadow-none d-inline-flex align-items-center gap-1 small"
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#flush-collapseOne"
                                          aria-expanded="false"
                                          aria-controls="flush-collapseOne"
                                          style={{ color: "var(--bs-primary)" }}
                                        >
                                          View Breakdown
                                        </button>
                                      </p>

                                    </div>

                                    {/* <div className="col-md-11 p-1 m-0 p-md-0 d-flex justify-content-between">
                                      <small className="">{plan.name || plan.bundleName}</small>
                                      <small>
                                        {plan?.planDuration ||
                                          plan?.duration}{" "}
                                        {plan?.durationType}
                                      </small>
                                    </div> */}
                                    <div className="accordion accordion-flush" id="accordionFlushExample">
                                      <div className="accordion-item border-0 rounded">
                                        <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                          <div className="accordion-body ">
                                            <div className="col-12 py-1 d-flex justify-content-between">
                                              <small className="text-muted">Duration</small>
                                              <small>
                                                {plan?.planDuration ||
                                                  plan?.duration}{" "}
                                                {plan?.durationType}
                                              </small>
                                            </div>
                                            <div className="col-12 py-1 d-flex justify-content-between">
                                              <small className="text-muted">Sub Total</small>
                                              <small className="">
                                                <IndianRupee size={12} />
                                                {data.total?.toLocaleString("en-IN")}
                                              </small>
                                            </div>
                                            <div className="col-12 py-1 d-flex justify-content-between">
                                              <small className="text-muted">GST (18%)</small>
                                              <small>
                                                <IndianRupee size={12} />
                                                {data.gst?.toLocaleString("en-IN")}
                                              </small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-11 py-1 d-flex justify-content-between">
                                      <small className="fw-semibold">Total</small>
                                      <small className='fw-semibold me-1'>
                                        <IndianRupee size={12} />
                                        {data.grandTotal?.toLocaleString("en-IN")}
                                      </small>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div >
                            <div className="col-md-3 d-none">
                              <h5 className="fw-bold">
                                Proceed with payment
                              </h5>
                            </div>

                            <div className="col-md-3 d-none">
                              <h5 className="fw-bold">Package</h5>
                              <small
                                key={plan.id}
                                className="px-2 rounded-3 bg-primary bg-opacity-10 fw-semibold d-inline-block me-2"
                              >
                                {plan.name}
                              </small>
                            </div>

                            <div className="col-md-3 d-none">
                              <h5 className="fw-bold">
                                <IndianRupee size={18} /> {data.total}
                              </h5>
                              <small> + 18% GST</small>
                            </div>

                            <div className="col-md-3 d-none">
                              <MakePaymentProcess
                                planData={data?.planData}
                                componentKey={data?.componentKey}
                                total={data?.total}
                                gst={data?.gst}
                                grandTotal={data?.grandTotal}
                                sourceData={data?.sourceData}
                              />
                            </div>
                            {/* </div> */}
                          </>
                        );
                      })()}
                    </>
                  )}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        }
      </section >
    </div >
    // </Layout>
  )
}
